import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { AccountUserInfo } from './account.model';

export type AccountEventBusTypes = 'onAccountUpdate' | 'onAccountEmpty' | 'onAccountLogout';
export interface AccountEventBus {
  event: AccountEventBusTypes;
  data?: AccountUserInfo;
}

@Injectable({
  providedIn: 'root'
})

export class AccountStoryService {
  public AccountEventBus: ReplaySubject<AccountEventBus> = new ReplaySubject<AccountEventBus>(1);
  public AccountEventBus$ = this.AccountEventBus.asObservable();
}
